import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { criterionLabel } from '../landscapeForm';
/** "Rule: agency = DHS" for a rule member, "Manual" otherwise, plus any suppression reason. */ export function MemberBasis({ basis, ruleKind, ruleValue, suppressionReason }) {
    const isRule = basis === 'rule';
    return /*#__PURE__*/ _jsxs("span", {
        className: "inline-flex flex-wrap items-center gap-2",
        children: [
            /*#__PURE__*/ _jsx(SpecraBadge, {
                variant: isRule ? 'info' : 'neutral',
                "data-testid": Testids.landscapes.basisBadge,
                children: isRule ? `Rule: ${criterionLabel(ruleKind)} = ${ruleValue}` : 'Manual'
            }),
            suppressionReason && /*#__PURE__*/ _jsxs("span", {
                className: "text-xs text-muted-foreground",
                "data-testid": Testids.landscapes.suppressionReason,
                children: [
                    "Suppressed: ",
                    suppressionReason
                ]
            })
        ]
    });
}
